import { Theme } from '@mui/material/styles'

const muiPagination = (_theme: Theme) => {
  return {
    styleOverrides: {
      root: {}
    }
  }
}

export default muiPagination
